export default __webpack_public_path__ + "static/media/serviceBlock3.0d62c8e0.jpeg";